import React from 'react'

export default function Services() {
  return (
    <div>
      
      <section id="cta" className="cta">
      <div className="container" data-aos="zoom-in">

        <div className="text-center">
          <h3> Services </h3>
          <p> We assure our customers for their valid claims and provide them better facilities in all our products. </p>
          <a className="cta-btn" href="/contact">Contact Us</a>
        </div>

      </div>
    </section>

    </div>
  )
}
